import React from 'react';
import styles from './DropdownSearch.module.scss';
import ValidationIcons from '../ValidationIcons/ValidationIcons';
import CustomSearchSelect, {
  type ICustomSearchSelect,
} from './CustomSearchSelect/CustomSearchSelect';
import { type IOption } from '../shared/models/IOption';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import AssistiveText from '../AssistiveText/AssistiveText';

export interface IDropdownSearch {
  showTags?: boolean;
  options: IOption[];
  prioritizedOptions?: IOption[];
  onChange?: (value: IOption | null) => void;
  customOptionsFilter?: (collection: IOption[], filter: string) => IOption[];
  id: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  defaultOption?: IOption;
  isValid?: boolean;
  errorMessage?: string;
  assistiveText?: string;
  searchPlaceholder?: string;
  searchAriaLabel?: string;
  prioritizedItemsAlertText?: string;
  clearSearchButtonAriaLabel?: string;
  noOptionsFoundText?: string;
}

export default function DropdownSearch({
  showTags = false,
  options,
  prioritizedOptions = [],
  onChange,
  customOptionsFilter,
  id,
  label,
  placeholder,
  disabled = false,
  defaultOption,
  isValid,
  errorMessage,
  assistiveText,
  searchPlaceholder = 'Search',
  searchAriaLabel = 'Search for options',
  prioritizedItemsAlertText,
  clearSearchButtonAriaLabel,
  noOptionsFoundText,
}: IDropdownSearch) {
  const customSearchSelectProps: ICustomSearchSelect = {
    showTags,
    options,
    prioritizedOptions,
    onChange,
    customOptionsFilter,
    id,
    placeholder,
    disabled,
    isValid,
    defaultOption,
    searchPlaceholder,
    searchAriaLabel,
    prioritizedItemsAlertText,
    clearSearchButtonAriaLabel,
    noOptionsFoundText,
  };
  return (
    <div className={styles.dropdown}>
      <label id={`${id}-label`} htmlFor={`${id}-button`}>
        {label}
      </label>
      <div className={styles.customSelectContainer}>
        <div className={styles.customSelectInnerContainer}>
          <CustomSearchSelect {...customSearchSelectProps} />
          <ValidationIcons isValid={isValid} />
        </div>
        <ErrorMessage isValid={isValid}>{errorMessage}</ErrorMessage>
        <AssistiveText>{assistiveText}</AssistiveText>
      </div>
    </div>
  );
}
